<template>
  <div class="va-code-input">
    <div class="va-code-input__label-wrapper d-flex align-center">
      <p class="va-code-input__label">
        {{ title }}
      </p>
      <template v-if="info">
        <info-tooltip :info="info"></info-tooltip>
      </template>
    </div>
    <codemirror @ready="ready" :value="value" :options="cmOptions" @update="updateCode"></codemirror>
  </div>
</template>

<script>
  import { codemirror } from "vue-codemirror";
  import "codemirror/lib/codemirror.css";
  import "codemirror/theme/monokai.css";

  import "codemirror/mode/javascript/javascript.js"; // Mode for Javascript / JSON

  import "codemirror/mode/htmlmixed/htmlmixed"; // Mode for HTML
  import "codemirror/addon/edit/closetag"; // For auto-closing tags
  import "codemirror/addon/edit/matchtags"; // For matching tags
  import "codemirror/addon/fold/xml-fold"; // For folding HTML tags

  import InfoTooltip from "./InfoTooltip";

  export default {
    name: "CodeInput",
    components: {
      codemirror,
      InfoTooltip,
    },
    props: {
      value: {
        type: String,
        default: "",
      },
      title: {
        type: String,
        default: "",
      },
      // Info disclaimer near the label
      info: {
        type: String,
        default: "",
      },
      mode: {
        type: String,
        default: "htmlmixed", // HTML by default
      },
      options: {
        type: Object,
        default: () => ({}),
      },
    },
    setup(props, { emit }) {
      const cmOptions = {
        tabSize: 4,
        mode: props.mode,
        theme: "monokai", // Set theme, replace 'default' with any theme you like
        lineNumbers: true, // Display line numbers
        line: true,
        autoCloseTags: true, // Enable auto-closing of tags
        matchTags: { bothTags: true }, // Highlight matching tags
        foldGutter: true, // Enable gutter for folding tags
        gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter"], // Add gutters
        viewportMargin: Infinity,
        ...props.options,
      };

      const ready = editor => {
        /**
         * Doesn't work when trying to call editor.refresh without settimeout
         * Doesn't work when trying to call inside of a nextTick either.
         */
        setTimeout(() => {
          editor.refresh();
        }, 1);
        emit("ready", editor);
      };

      const updateCode = codeMirror => {
        emit("input", codeMirror.getValue());
      };

      return {
        props,
        cmOptions,
        updateCode,
        ready,
      };
    },
  };
</script>
<style lang="scss" scoped>
  @import "../../@core/preset/preset/typography/index.scss";
  @import "../../@core/preset/preset/functions.scss";

  .va-code-input {
    .va-code-input__label {
      @include text-caption-bold();
      color: get-color("subtitle");
      &-wrapper {
        margin-bottom: 6px;
      }
    }
    &::v-deep {
      .CodeMirror {
        border-radius: 4px !important;
      }
    }
  }
</style>
